import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

export interface ToolbarFilterButton {
  value: string;
  label: string;
  count?: number;
  colorClass?: string;
  icon?: string;
}

export interface ToolbarFilterSelect {
  label: string;
  value: string;
  options: { value: string; label: string; count?: number }[];
}

// Backward-compat alias used by migrated screens
export type FilterSelect = ToolbarFilterSelect;

@Component({
  selector: 'app-data-table-toolbar',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './data-table-toolbar.component.html',
  styleUrls: ['./data-table-toolbar.component.scss']
})
export class DataTableToolbarComponent implements OnInit, OnDestroy {
  @Input() filterButtons: ToolbarFilterButton[] = [];
  @Input() activeFilter: string = '';
  @Input() filterSelects: ToolbarFilterSelect[] = [];
  @Input() searchPlaceholder: string = 'Buscar...';
  @Input() searchValue: string = '';
  @Input() showSearch: boolean = true;
  @Input() filterButtonsLabel: string = 'Status:';
  @Input() searchDebounceTime: number = 2000; // 2 segundos de debounce padrão

  @Output() filterChange = new EventEmitter<string>();
  @Output() selectChange = new EventEmitter<{ field: string; value: string }>();
  @Output() searchChange = new EventEmitter<string>();

  private readonly searchSubject = new Subject<string>();
  private searchSubscription?: Subscription;

  ngOnInit(): void {
    // Configura debounce para a busca
    this.searchSubscription = this.searchSubject.pipe(
      debounceTime(this.searchDebounceTime),
      distinctUntilChanged()
    ).subscribe(value => {
      this.searchChange.emit(value);
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription?.unsubscribe();
  }

  onFilterClick(value: string): void {
    this.filterChange.emit(value);
  }

  onSelectChange(label: string, value: string): void {
    this.selectChange.emit({ field: label, value });
  }

  onSearchInput(value: string): void {
    // Envia para o subject que aplica debounce
    this.searchSubject.next(value);
  }
}
